module.exports = __webpack_public_path__ + "media/images/icon_upload-ef888a1e.svg";